import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import LocalStrings from '../../assets/languages';
import { removeSpecialCharacters } from '../../util/util-common';

/**
 *
 *          PARAMS FOR THIS COMPONENT
 *
 * @param text: the text needed to be supplied
 * @param maxLines: how many max lines to render, default set to 5
 * @param expand: if you want the text section to expand with 'Show More' click, default none
 * @param textStyle: the supplied text style, default set to ''. If '' then 'custom-text1-normal' is used
 * @param readMore: special boolean param, default true
 * @param attendeeList: app's fetched attendee list reducer
 * @param attendeeRedirection: Attendee redirection handler function
 *
 *
 *
 */

const TextWithLink = props => {
  const {
    text,
    maxLines = 5,
    expand = false,
    textStyle = '',
    readMore = true,
    attendeeList = null,
    attendeeRedirection = null
  } = props;
  const [more, setMore] = useState(false);
  const [maxLineState, setMaxLineState] = useState(maxLines);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    // Resetting the state variables on text change
    setMore(false);
    setMaxLineState(maxLines);
    setIsOverflowing(false);

    const element = elementRef.current;
    if (element) {
      const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
      const maxHeight = lineHeight * maxLines;
      setIsOverflowing(element.scrollHeight > maxHeight);
    }
  }, [text, elementRef?.current?.scrollHeight]); // Including text change as if component doesn't unmount but text value changes

  let titleStrArr = [];
  if (text && text !== '' && text.trim() !== '') {
    let local_text = text.replace(/\n/g, ' \n');
    titleStrArr = local_text.split(' ');
  }

  const _renderMentioned = (word, k) => {
    let mentionedUser = null;

    if (!_.isEmpty(attendeeList?.data)) {
      let mentionedUserId = removeSpecialCharacters(word, true);

      mentionedUser = _.find(
        attendeeList?.data,
        attendee => attendee?.appuserid == mentionedUserId
      );
    }

    const handleAttendeeRedirection = () => {
      attendeeRedirection && attendeeRedirection(mentionedUser);
    };

    return (
      <span
        key={`title_key_mention_${k}`}
        className={`custom-whatever-text-theme-color cursor-pointer`}
        onClick={handleAttendeeRedirection}
      >
        {!_.isEmpty(mentionedUser) ? mentionedUser?.username : ''}{' '}
      </span>
    );
  };

  const _renderHyperLinks = (word, k) => {
    let linkUrl = word;

    if (word.includes('\n')) {
      let localWordArr = word.split('\n');

      linkUrl = _.find(
        localWordArr,
        linkWord =>
          linkWord.includes('http') ||
          linkWord.includes('https') ||
          linkWord.includes('www')
      );
    }

    return (
      <span key={`title_key_link_${k}`} className={localTextStyle}>
        <a
          href={linkUrl}
          target="_blank"
          style={{ textDecoration: 'underline' }}
        >
          {`${word} `}
        </a>
      </span>
    );
  };

  const _renderNewLine = (word, k) => {
    let newWord = titleStrArr[k - 1] === '\n' ? word.replace(/\n/g, '') : word;
    let newLineArr = newWord.split('\n');
    let newLineOccurrence = (newWord.match(/\n/g) || []).length;

    return _.map(newLineArr, (text, index) => {
      if (text === '') {
        return (
          <React.Fragment key={`new_line_${text}_${index}`}>
            <br />
            {newLineOccurrence > 1 && <br />}
          </React.Fragment>
        );
      } else {
        return (
          <span key={`new_line_${text}_${index}`} className={localTextStyle}>
            {text + ' '}
          </span>
        );
      }
    });
  };

  const maxlineStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: maxLineState,
    WebkitBoxOrient: 'vertical'
  };

  const localTextStyle = textStyle === '' ? 'custom-text1-normal' : textStyle;

  return titleStrArr.length > 0 ? (
    <>
      <div style={maxlineStyle} ref={elementRef}>
        {_.map(titleStrArr, (word, k) => {
          const isMention =
            _.includes(word, '<&#;') && _.includes(word, ';#&>');
          const isHyperLink =
            _.toLower(word).includes('http') ||
            _.toLower(word).includes('https') ||
            _.toLower(word).includes('www.');
          const hasNewLine = word.includes('\n');

          if (isMention) {
            return _renderMentioned(word, k);
          } else if (isHyperLink) {
            return _renderHyperLinks(word, k);
          } else if (hasNewLine) {
            return _renderNewLine(word, k);
          }
          return (
            <span
              key={`title_key_normal_${word}_${k}`}
              className={localTextStyle}
            >
              {word + ' '}
            </span>
          );
        })}
      </div>

      {isOverflowing && readMore && (
        <>
          {!more ? (
            <>
              <div
                className={`custom-whatever-text-theme-${
                  !expand ? `color` : `link`
                } cursor-pointer ${localTextStyle} mt-3`}
                onClick={() => {
                  if (expand) {
                    setMore(!more);
                    setMaxLineState(1000);
                  }
                }}
                key={`more_text_1`}
              >
                {LocalStrings.dynamic.kReadMore}
              </div>
            </>
          ) : more ? (
            <>
              <div
                className={'custom-text1-medium-theme-link mt-3'}
                onClick={() => {
                  setMore(!more);
                  setMaxLineState(maxLines);
                }}
                key={`more_text_2`}
              >
                {LocalStrings.dynamic.kReadLess}
              </div>
            </>
          ) : (
            ''
          )}
        </>
      )}
    </>
  ) : null;
};

export default TextWithLink;
